import { useTranslation } from "../../state/i18n";
import { DestructiveModal } from "../../components/modal/Modal";
import ApiService from "../../services/ApiService";
import { useModalManager } from "../../components/modal/ModalManager";
import GenericFailureModal from "../GenericFailureModal";
import type { VoidComponent } from "solid-js";
import { untrack } from "solid-js";
import type DataSourceId from "../../state/DataSourceId";
import { useNavigate } from "@solidjs/router";
import type CustomerId from "../../state/CustomerId";

type DeleteDataSourceConfirmationModalProps = {
  customerId: CustomerId;
  dataSourceId: DataSourceId;
};
const DeleteDataSourceConfirmationModal: VoidComponent<DeleteDataSourceConfirmationModalProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { replace } = useModalManager();

  const deleteDataSource = async (dataSourceId: DataSourceId) =>
    ApiService.deleteDataSource().mutateAsync(dataSourceId, {
      onSuccess: () => {
        navigate(`/customers/${props.customerId}/data-sources`);
      },
      onError: (err) => {
        replace({
          content: () => <GenericFailureModal title={t(($) => $.DELETE_DATASOURCE_FAILURE_MODAL_TITLE)} error={err} />,
        });
      },
    });

  return (
    <DestructiveModal
      title={t(($) => $.DELETE_DATASOURCE_CONFIRMATION_MODAL_TITLE)}
      description={t(($) => $.DELETE_DATASOURCE_CONFIRMATION_MODAL_DESCRIPTION)}
      confirmLabel={t(($) => $.DELETE_DATASOURCE_CONFIRMATION_MODAL_ACTIONS_CONFIRM)}
      confirmLabelSlow={t(($) => $.DELETE_DATASOURCE_CONFIRMATION_MODAL_ACTIONS_CONFIRM_SLOW)}
      cancelLabel={t(($) => $.DELETE_DATASOURCE_CONFIRMATION_MODAL_ACTIONS_CANCEL)}
      onConfirm={() => deleteDataSource(untrack(() => props.dataSourceId))}
    />
  );
};

export default DeleteDataSourceConfirmationModal;
